module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('legend', {
    staticClass: "col-form-label pt-0"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('item.seller')) + " *\n\t\t\t"), (_vm.activePerson) ? _c('span', [_c('b-button-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "target": "_blank",
      "to": {
        name: 'personEdit',
        params: {
          personId: _vm.activePerson.id
        }
      },
      "variant": "outline-primary",
      "title": _vm.$t('common.editPerson', {
        name: _vm.activePerson.full_name
      })
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "edit"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "target": "_blank",
      "to": {
        name: 'auctionSeller',
        params: {
          personId: _vm.activePerson.id
        }
      },
      "title": _vm.$t('auction.activityOf', {
        name: _vm.activePerson.full_name
      })
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "user"
    }
  })], 1)], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('autocomplete-person', {
    attrs: {
      "selected": _vm.selectedPerson,
      "label": null,
      "deletable": false,
      "allow-empty": false
    },
    on: {
      "update:person": _vm.changeSellerModal
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "block": "",
      "variant": "outline-primary",
      "title": _vm.$t('person.add')
    },
    on: {
      "click": _vm.showModal
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "plus"
    }
  })], 1)], 1), _vm._v(" "), _c('base-dialog-modal', {
    ref: "personDialogModal",
    attrs: {
      "title": _vm.$t('person.add')
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.formError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('person-form-fields', {
    attrs: {
      "form": _vm.form
    },
    on: {
      "update:form": function($event) {
        _vm.form = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "block": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n\n\t\t\t\t\t\t" + _vm._s(_vm.$t('common.cancel')) + "\n\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "block": "",
      "variant": "outline-success"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_c('loader-spinner', {
    attrs: {
      "text": _vm.$t('common.create'),
      "show-spinner": _vm.isFetching
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('base-dialog-modal', {
    ref: "changeSellerModal",
    attrs: {
      "hide-header-close": true,
      "no-close-on-backdrop": true,
      "no-close-on-esc": true,
      "title": _vm.$t('item.changeSeller')
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('item.changeSellerModal', {
    sellerName: _vm.modals.seller.title
  })) + "\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "block": ""
    },
    on: {
      "click": _vm.cancelSellerModal
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "disabled": _vm.modals.seller.loading,
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        return _vm.personIsUpdated(_vm.modals.seller.selected)
      }
    }
  }, [_c('loader-spinner', {
    attrs: {
      "text": _vm.$t('item.changeSeller'),
      "show-spinner": _vm.modals.seller.loading
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-663dbd7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Item/Form/SellerField.vue
// module id = 1320
// module chunks = 1